import { render, staticRenderFns } from "./brokerInsuredApprovalList.vue?vue&type=template&id=53d682e7&scoped=true"
import script from "./brokerInsuredApprovalList.vue?vue&type=script&lang=js"
export * from "./brokerInsuredApprovalList.vue?vue&type=script&lang=js"
import style0 from "./brokerInsuredApprovalList.vue?vue&type=style&index=0&id=53d682e7&prod&lang=css"
import style1 from "./brokerInsuredApprovalList.vue?vue&type=style&index=1&id=53d682e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d682e7",
  null
  
)

export default component.exports